import classNames from 'classnames'
import React, { FC, ReactNode } from 'react'

import imageResize, { generateSrcSet } from 'project/image-proxy-web'
import useWindowSize from 'components/util/useWindowSize'

type RobotImage = {
  alt?: string
  desktop: {
    src: string
    dimensions: {
      width: number
      height: number
    }
  }
  mobile: {
    src: string
    dimensions: {
      width: number
      height: number
    }
  }
}

type RightRobotCardType = {
  className?: string
  image: RobotImage
  imageContainerWidth?: string
  children: ReactNode
  reverseColumnOrder?: boolean
  imagePosition?: string
  imageStyle?: React.CSSProperties
  overrideAllImageStyles?: boolean
}

const RightRobotCard: FC<RightRobotCardType> = ({
  children,
  className,
  image,
  imageContainerWidth,
  imageStyle,
  overrideAllImageStyles = false,
  reverseColumnOrder = false,
}) => {
  const size = useWindowSize()
  const {
    alt: imageAlt = 'Colorful robot figure with stickers',
    desktop,
    mobile,
  } = image

  return (
    <div className={`card right-robot-card ${className}`}>
      <div
        className={classNames('d-flex flex-lg-row', {
          'flex-column': !reverseColumnOrder,
          'flex-column-reverse': reverseColumnOrder,
        })}
      >
        {children}
        <div
          style={{
            width: imageContainerWidth,
          }}
          className={'d-flex justify-content-end position-relative'}
        >
          {size.isLgOrHigher ? (
            <img
              {...generateSrcSet(
                desktop.src,
                desktop.dimensions.width,
                desktop.dimensions.height,
              )}
              loading='lazy'
              alt={imageAlt}
              className={classNames({
                'rounded-right-img': !reverseColumnOrder,
              })}
              style={
                !size.isXlOrHigher && !overrideAllImageStyles
                  ? {
                      objectFit: 'cover',
                      objectPosition: 'left',
                      width: '100%',
                    }
                  : {
                      bottom: 0,
                      position: 'absolute',
                      right: 0,
                      ...imageStyle,
                    }
              }
            />
          ) : (
            mobile.src !== 'none' && (
              <img
                {...generateSrcSet(
                  mobile.src,
                  mobile.dimensions.width,
                  mobile.dimensions.height,
                )}
                loading='lazy'
                alt={imageAlt}
                className={classNames('w-100 h-auto', {
                  'rounded-bottom-img': !reverseColumnOrder,
                  'rounded-top-img': reverseColumnOrder,
                })}
              />
            )
          )}
        </div>
      </div>
    </div>
  )
}

export default RightRobotCard
